import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { CapsuleButton, ContentSpace, ListedGroup, MainPageWithButtons } from "../../Common/_components";
import { DevelopersStore } from "../DevelopersStore";
import { DevOauth } from "../_models/DevOauth";
import { DevUser } from "../_models/DevUser";
import { Icons } from "../../Common/_assets/icons/Icons";
import { DevOauthActions } from "../_actions/DevOauthActions";
import { DevUserActions } from "../_actions/DevUserActions";
import { GenericTextArea } from "../../Common/_components/GenericTextArea";
import { TextInputComponent } from "../../Common/_components";

const devOauth = DevOauth();
const devUser = DevUser();

export function DevOauthModule() {
    
    //LIBRARIES
    const dispatch = useDispatch();
    const { t } = useTranslation();

    //GLOBAL STATE
    let oauthData = devOauth;
    oauthData = useSelector(DevelopersStore.selectors.getOauth);
    
    let user = devUser;
    user = useSelector(DevelopersStore.selectors.getUser);

    //ACTION HANDLERS
    //function handleCopyToClipboard(text) {
    //    navigator.clipboard.writeText(text);
    //}

    //INTIALIZATION
    useEffect(() => {
        dispatch(DevOauthActions.getOauthData());
        dispatch(DevUserActions.getUser())
    }, [dispatch]);

    //VIEW
    return (
        <ContentSpace
            mainContent={
                <MainPageWithButtons
                    pageTitle={"OAUTH2 Data"}
                    content={content()}
                />
            }
        />
    );

    function content() {
        return (
            <div>
                <div className="mt-2"/>
                <ListedGroup
                    headerText={"App Data"}
                    elements={ui()}
                />
                {user.debugOnly && 
                    <div className="alert alert-warning mt-3">
                        <p><b>La cuenta está en modo pruebas</b></p>
                        <p>Solo puedes usar tu cuenta ({user.email}) para el flujo de autenticación OAuth.</p>
                        <br></br>
                        <p>Una vez que hayas probado que la integración funciona correctamente contacta con nosotros para pasarla a producción.</p>
                    </div>
                }
                {!user.debugOnly && 
                    <div className="alert alert-info mt-3">
                        <p><b>La cuenta está en modo producción</b></p>
                    </div>
                }
            </div>
        );

        function ui() {
            if (oauthData == null) {
                return [
                    <div className="text-center my-2">
                        {t("mod_dev_tokens_none_found")}
                    </div>
                ];
            }
            
            return [
                <div className="h-100 d-flex no-gutters flex-column">
                    <AppNameInput initialName={oauthData.name} />
                    <RedirectUrisInput initialRedirectUris={oauthData.redirect_uris} />
                    <ClientIdToken clientId={oauthData.client_id} />
                    <ClientSecretToken clientSecret={oauthData.client_secret} />
                </div>
            ];
        }

        function AppNameInput({initialName}) {

            const [name, setName] = useState(initialName);
            const [isNameEdited, setNameIsEdited] = useState(false);

            //LIBRARIES
            //const { t } = useTranslation();
            const dispatch = useDispatch();
        
            //ACTION HADLERS
            function handleUpdateName(name) {
                if (!isNameEdited) {
                    setNameIsEdited(true);
                }
                setName(name);
            }

            function handleResetName() {
                setNameIsEdited(false);
                setName(oauthData.name);
            }

            function handleSaveName() {
                dispatch(DevOauthActions.updateAppName(name));
            }
        
            return (
                <DataWrapper hasSeparator={false}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            App Name
                        </div>
                        <TextInputComponent
                            placeholder={undefined}
                            value={name}
                            onChange={handleUpdateName}
                            type={'text'}
                            isEditable={true}
                        />
                        {isNameEdited &&
                            <div className="flex-shrink-0 d-flex justify-content-end align-items-start">
                                <div className="ml-2"/>
                                <CapsuleButton
                                    icon={Icons.cross}
                                    size={'SMALL'}
                                    onClick={handleResetName}
                                    textUppercase={false}
                                    style={`DANGER`}
                                />
                                <div className="ml-2"/>
                                <CapsuleButton
                                    icon={Icons.check}
                                    size={'SMALL'}
                                    onClick={handleSaveName}
                                    textUppercase={false}
                                />
                            </div>
                        }
                    </div>
                </DataWrapper>
            );
        }

        function RedirectUrisInput({initialRedirectUris}) {
            
            const [isUrisEdited, setUrisIsEdited] = useState(false);
            const [redirectUris, setRedirectUris] = useState(initialRedirectUris);

            //LIBRARIES
            //const { t } = useTranslation();
        
            //ACTION HADLERS
            function handleUpdateRedirectUris(redirectUris) {
                if (!isUrisEdited){
                    setUrisIsEdited(true);
                }
                setRedirectUris(redirectUris);
            }

            function handleResetRedirectUris() {
                setUrisIsEdited(false);
                setRedirectUris(oauthData.redirect_uris);
            }

            function handleSaveRedirectUris() {
                dispatch(DevOauthActions.updateRedirectUris(redirectUris));
            }

            return (
                <DataWrapper hasSeparator={false}>
                    <div
                        className="d-flex align-items-center justify-content-between"
                    >
                        <div>
                            <span>Redirect URLs</span>
                            <br></br>
                            <span className="c-new-ft-s">(Puedes añadir más de una url separadas por espacios)</span>
                        </div>
                        <GenericTextArea
                            text={redirectUris}
                            handleEditText={handleUpdateRedirectUris}
                            placeholder={undefined}
                        />
                        {isUrisEdited &&
                            <div className="flex-shrink-0 d-flex justify-content-end align-items-start">
                                <div className="ml-2"/>
                                <CapsuleButton
                                    icon={Icons.cross}
                                    size={'SMALL'}
                                    onClick={handleResetRedirectUris}
                                    textUppercase={false}
                                    style={`DANGER`}
                                />
                                <div className="ml-2"/>
                                <CapsuleButton
                                    icon={Icons.check}
                                    size={'SMALL'}
                                    onClick={handleSaveRedirectUris}
                                    textUppercase={false}
                                />
                            </div>
                        }
                    </div>
                </DataWrapper>
            );
        }

        function DataWrapper({
            children,
            hasSeparator = true,
            key,
        }) {
            return (
                <div key={key}>
                    <div className="p-1">
                        {children}
                    </div>
                    {hasSeparator && <hr className="m-0"/>}
                </div>
            );
        }
        
        function ClientIdToken({ clientId }) {
            return (
                <div className="d-flex p-1 justify-content-between align-items-center">
                    <div className="d-flex align-align-items-end">
                        <div>Client ID</div>
                        <div className="ml-2" />
                        <div className="bg-light border rounded px-1 text-break">
                            {clientId}
                        </div>
                        <div className="ml-2" />
                    </div>
                </div>
            )
        }

        function ClientSecretToken({ clientSecret }) {
            return (
                <div className="d-flex p-1 justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div>Client Secret</div>
                        <div className="ml-2" />
                        <div className="bg-light border rounded px-1 text-break">
                            {clientSecret}
                        </div>
                        <div className="ml-2" />
                    </div>
                </div>
            )
        }
    }
}